export default "__VITE_ASSET__BCZV2zyE__"